import React, { Dispatch, SetStateAction } from 'react';
import { useEffect, useRef, useState } from 'react';
import { MenuItem } from '../Menu/VoxelMenu';

export interface VoxelUnderlinedTabsProps {
  menuListItems: MenuItem[];
  selectedId?: any;
  setSelectedId: Dispatch<SetStateAction<any>>;
  size?: 'xs' | 'sm' | 'md';
  transition?: boolean;
  highlight?: 'gray' | 'primary';
  removeBorder?: boolean;
}

export const VoxelUnderlinedTabs: React.FC<VoxelUnderlinedTabsProps> = ({
  menuListItems,
  selectedId,
  setSelectedId,
  size = 'md',
  transition = true,
  highlight = 'primary',
  removeBorder
}) => {
  const test = (index: number) => {
    setActiveTabIndex(index);
    setSelectedId(menuListItems[index].id);
  };

  const [activeTabIndex, setActiveTabIndex] = useState(
    menuListItems?.map((t) => t.id)?.indexOf(selectedId)
  );
  const [tabUnderlineWidth, setTabUnderlineWidth] = useState(0);
  const [tabUnderlineLeft, setTabUnderlineLeft] = useState(0);

  const tabsRef = useRef([]);

  useEffect(() => {
    function setTabPosition() {
      setActiveTabIndex(menuListItems?.map((t) => t.id)?.indexOf(selectedId));
      const currentTab = tabsRef.current[activeTabIndex];
      setTabUnderlineLeft(currentTab?.offsetLeft ?? 0);
      setTabUnderlineWidth(currentTab?.clientWidth ?? 0);
    }

    setTabPosition();
    window.addEventListener('resize', setTabPosition);

    return () => window.removeEventListener('resize', setTabPosition);
  }, [selectedId, activeTabIndex]);

  let highlightTab = 'text-primary-600 hover:bg-primary-500/10';
  let highlightUnderline = 'bg-primary-500';
  if (highlight === 'gray') {
    highlightTab = 'text-voxel-gray-600 hover:bg-gray-500/10';
    highlightUnderline = 'bg-voxel-gray-300';
  }
  return (
    <div>
      <div className="relative">
        <div className={`flex space-x-1.5 ${removeBorder ? '' : 'border-b'}`}>
          {menuListItems.map((tab, idx) => {
            return (
              <button
                key={idx}
                ref={(el) => (tabsRef.current[idx] = el)}
                onClick={() => test(idx)}
                className={`px-2 py-1 mb-[3px] rounded-lg 
                font-medium font-sans text-center 
                ${activeTabIndex === idx && highlightTab}
                ${activeTabIndex !== idx && 'text-voxel-gray-400 hover:bg-voxel-gray-100'}
                ${size === 'md' ? 'text-sm' : ''}
                ${size === 'sm' ? 'text-[13px]' : ''}
                ${size === 'xs' ? 'text-xs' : ''}
                `}
              >
                {tab.name}
              </button>
            );
          })}
        </div>
        <span
          className={`absolute bottom-0 block h-0.5 ${highlightUnderline} ${transition && 'transition-all duration-300'
            }`}
          style={{ left: tabUnderlineLeft, width: tabUnderlineWidth }}
        />
      </div >
    </div >
  );
};

export default VoxelUnderlinedTabs;
